module.exports = __webpack_public_path__ + "media/images/pic/advantage-mobile-f59e39d4e07306831c5544df87b3e653.png";